/**
 * Created by anthony on 7/9/14.
 */
var helpCardParagraph = angular.module('helpCardParagraph', ['helpCardMessage', 'helpButton']);
helpCardParagraph.directive('helpCardParagraph', function($compile) {
    return {
        restrict: 'E',
        scope: { paragraph: '=', helpMsg: '=' },
        templateUrl: 'ism-angular-lib/directives/helpCardParagraph/helpCardParagraph.html?v=' + versionNo,
        link: function(scope, elem, attrs) {
            scope.paragraph += '<help-card-message ng-repeat="item in helpMsg "active="active[$index]" help-msg="item"></help-card-message>';
            var el = angular.element(scope.paragraph);
            //compile the view into a function.
            var compiled = $compile(el);
            //append our view to the element of the directive.
            elem.append(el);
            //bind our view to the scope!
            //(try commenting out this line to see what happens!)
            compiled(scope);
        },
        controller: function($scope)
        {
            var i = 0;
            $scope.active = [];
            angular.forEach($scope.helpMsg, function(value, key) {
                $scope.active[i] = false;
                i++;
            });
            $scope.versionNo = versionNo;

        }
    };
});